import React, { useContext, useEffect, useState } from "react";
import { useTheme } from "emotion-theming";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { getStringFromId } from "helpers/vernacular";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { PAYMENT_MODES } from "constants/paymentModes";
import { getPlatform } from "../../../helpers";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { get } from "logics/src/utils/helpers";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { doAttachWebCallback, WebCallback } from "helpers/utils/webView";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { BUTTON_TYPE, CRED_PAY_UPI } from "constants/index";
import CredPay from "@nykaa/payment-sdk/src/CredPay/mobile";


const CredWrapper = ({
  doPayment,
  isAccordianOpened,
  toggleNewPaymentAccordian,
  endIcon,
  isDisabled,
  strikedPaymentText,
  credPayData,
  timerCallback,
  setUpiDetails,
}: any) => {
  if (!credPayData.eligible) {
    return null;
  }
  /* eslint-disable react-hooks/rules-of-hooks */
  const paymentContext: any = useContext(PaymentContext);
  const paymentInfo = get(paymentContext, "paymentInfo");
  const credDetailsDTO = get(paymentInfo, "credDetailsDTO");
  const upiMapping = get(paymentInfo, "upiMapping");

  const setLoading = paymentContext?.setLoading;
  /* eslint-disable react-hooks/rules-of-hooks */
  const { applicationData } = useContext(ApplicationContext);
  const isApp = applicationData?.isApp;

  const errorModalContext = useContext(ErrorModalContext);
  const openErrorModal = errorModalContext?.openErrorModal;

  const grandTotal = paymentContext?.orderAmount;

  const payNowText = getStringFromId(VERNACULAR_STRING_IDS.DYNAMIC_PAY, `Pay ₹${grandTotal}`, {
    count: grandTotal,
  });

  const theme = useTheme() as Theme;

  /* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
  const [vpaDetails, setVpa] = useState({
    error: "",
    hasError: false,
    showSavedVpa: false,
    title: "",
    vpa: "",
    icon: "",
    notifyIcon: "",
    message: "",
    amountToPay: 0,
  });

    /**
   * function for upi intent error handling.
   */
    const credUpiIntentErrorHandler = () => {
      setLoading(false);
      const errorMsg = "Something went wrong.";
      openErrorModal(PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG, errorMsg);
    };

  useEffect(() => {
    // it is for webview.
    if (isApp) {
      doAttachWebCallback({
        callbackName: WebCallback.DO_OPEN_CRED_INTENT_ERROR_CALLBACK,
        callbackDeclaration: credUpiIntentErrorHandler,
      });
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  const title = credDetailsDTO?.displayName
    ? credDetailsDTO?.displayName
    : getStringFromId(
        VERNACULAR_STRING_IDS.CRED_PAY_TITLE,
        VERNACULAR_DEFAULT_MESSAGES.CRED_PAY_TITLE
      );

  const subTitle = credDetailsDTO?.subText
    ? credDetailsDTO?.subText
    : getStringFromId(
        VERNACULAR_STRING_IDS.CRED_PAY_SUBTITLE,
        VERNACULAR_DEFAULT_MESSAGES.CRED_PAY_SUBTITLE
      );

  const leadingIcon = credDetailsDTO?.iconUrl;

  const platform = getPlatform();

  const credInfo = upiMapping?.find((list: any) => list?.title === CRED_PAY_UPI);

  const config = {
    title,
    subTitle,
    leadingIcon: leadingIcon || getIcons(platform, ICONS_NAMES.CRED_PAY),
    endIcon,
    toggleAccordian: () => toggleNewPaymentAccordian(PAYMENT_MODES.CRED, isDisabled),
    isAccordianOpened,
    payNowText,
    revisedPayNowText: strikedPaymentText,
    doPayment: () => {
      setLoading(true);
      /**
       * this is for title for polling screen in IOS
       */
      vpaDetails.amountToPay = grandTotal;
      setUpiDetails(vpaDetails);
      doPayment(PAYMENT_MODES.CRED, {
        timerCallback,
        packageName: credInfo?.package,
      });
    },
    isDisabled,
    theme,
    offerMessages: credPayData?.credOffer && [
      {
        text: credPayData?.credOffer,
        success: true,
        color: theme?.colors?.positive,
        font: theme?.typography?.bodySmall,
      },
    ],
    buttonType: BUTTON_TYPE.MEDIUM,
  };
  return <CredPay {...config} theme={theme} />;
};

export default CredWrapper;
